import React from "react";
import "../Report.css";

export default function ChurnReportTable({ data }) {
  const report = data || {};
  const columnGroups = Array.isArray(report.column_groups) ? report.column_groups : [];
  const groups = Array.isArray(report.groups) ? report.groups : [];
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    fontSize: "13px",
  };
  const thStyle = {
    padding: "10px 12px",
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    fontSize: "12px",
    color: "#f8fafc",
    background: "#2c3e66",
    border: "2px solid rgb(68 86 114)",
    textAlign: "center",
  };
  const tdStyle = {
    padding: "10px 12px",
    borderTop: "1px solid #e2e8f0",
    borderRight: "1px solid #f1f5f9",
    color: "#0f172a",
    textAlign: "center",
  };
  const rowTotalStyle = { background: "#ecfeff",  fontWeight: 600 };
  const rowGrandStyle = { background: "#2c3e66",color:"#eaedf4", border: "2px solid rgb(68 86 114)", fontWeight: 700 };
  const tdTotalStyle = { ...tdStyle, ...rowTotalStyle };
  const tdGrandStyle = { ...tdStyle, ...rowGrandStyle };

  return (
    <div className="report-table-container">
      {columnGroups.length > 0 ? (
      <table className="report-table" id="table-id" style={tableStyle}>
        <thead>
          <tr>
            <th rowSpan="2" style={thStyle}>Connect Type</th>
            <th rowSpan="2" style={thStyle}>Disposition</th>

            {columnGroups.map(group => (
              <th key={group.key} colSpan={group.metrics.length} style={thStyle}>
                {group.label}
              </th>
            ))}
          </tr>

          <tr>
            {columnGroups.map(group =>
              group.metrics.map(metric => (
                <th key={group.key + metric} style={thStyle}>{metric.toUpperCase()}</th>
              ))
            )}
          </tr>
        </thead>

        <tbody>

          {groups.map((group, gi) => {

            const rows = Array.isArray(group.rows)
              ? group.rows
              : [{ main_disposition: "-", ...group.rows }];

            const rowSpanCount = rows.length + 1; 

            return (
              <React.Fragment key={gi}>

                {rows.map((row, ri) => (
                  <tr key={ri}>

                    {ri === 0 && (
                      <td rowSpan={rowSpanCount} style={{ ...tdStyle, fontWeight: "bold", verticalAlign: "top" }}>
                        {group.connect_type}
                      </td>
                    )}

                    <td style={tdStyle}>{row.main_disposition}</td>

                    {columnGroups.map(col =>
                      col.metrics.map(metric => (
                        <td key={col.key + metric} style={tdStyle}>
                          {row[col.key]?.[metric] ?? "-"}
                        </td>
                      ))
                    )}

                  </tr>
                ))}

                <tr className="report-row-total">
                  <td style={tdTotalStyle}>Total</td>

                  {columnGroups.map(col =>
                    col.metrics.map(metric => (
                      <td key={col.key + metric} style={tdTotalStyle}>
                        {group.total?.[col.key]?.[metric] ?? "-"}
                      </td>
                    ))
                  )}
                </tr>

              </React.Fragment>
            );
          })}

          <tr className="report-row-grand">
            <td colSpan="2" style={tdGrandStyle}>Grand Total</td>

            {columnGroups.map(col =>
              col.metrics.map(metric => (
                <td key={col.key + metric} style={tdGrandStyle}>
                  {report.grand_total?.[col.key]?.[metric] ?? "-"}
                </td>
              ))
            )}
          </tr>

        </tbody>
      </table>
      ) : null}
    </div>
  );
}
